import PathObject from "../objects/path"
import Form from "./base"
import { bulgePath, bulgePathExportOutline } from "@/signomatic/util/shapes"

export default class BulgeForm extends Form {
  protected path(width: number) {
    return new PathObject(this.commands(width), this.defaultParams)
  }

  protected commands(width: number) {
    return this.isEngraving ? bulgePathExportOutline(width) : bulgePath(width)
  }
}
